var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1429 2H4.85714C3.27996 2.00188 2.00188 3.27996 2 4.85714V15.1429C2.00188 16.72 3.27996 17.9981 4.85714 18H15.1429C16.72 17.9981 17.9981 16.72 18 15.1429V4.85714C17.9981 3.27996 16.72 2.00188 15.1429 2ZM9.42859 16.8572H4.85714C3.91036 16.8572 3.14285 16.0896 3.14285 15.1429V4.85714C3.14285 3.91036 3.91036 3.14285 4.85714 3.14285H9.42856V16.8572H9.42859ZM16.8572 15.1429C16.8572 16.0896 16.0896 16.8572 15.1429 16.8572H10.5714V10.5714H16.8572V15.1429ZM16.8572 9.42859H10.5714V3.14285H15.1429C16.0896 3.14285 16.8572 3.91036 16.8572 4.85714V9.42859Z",
    fill: "#AAA9F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/layout.593337127f2d3373361435ebf2995443.svg";
export { ForwardRef as ReactComponent };